<template>
  <div>
    <van-empty description="暂无相关数据" />
  </div>
</template>

<script>
import { Empty } from 'vant'
export default {
  name: 'EmptyComponent',
  components: {
    [Empty.name]: Empty,
  }
}
</script>